// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vWMH","title":"Header_title__1Aip_","left":"Header_left__1g5zY","clinicName":"Header_clinicName__2jizx"};